<script lang="ts" setup>
import { useTracker } from '~/composables/tracker';
import { useTranslations } from '~/composables/translations';
import { requirejs } from '~/modules/require';

const { $i18n } = useTranslations('footer');

const tracker = useTracker();

const displayGeneralTermsAndConditions = async () => {
  tracker?.event('Terms&ConditionsClicked', 'Get info', 'Click on link');
  const [MarketplaceConnector, TCDocumentFactory] = await requirejs<[any, any]>([
    'DS/MPFDataProxy/MarketplaceConnector',
    'DS/MPFTcDocumentModel/TCDocumentFactory',
  ]);
  const connector = await MarketplaceConnector.fetchPromise();
  const docFacto = new TCDocumentFactory(connector);
  const contract = docFacto.createModel('general-public');

  contract.fetch({
    onComplete() {
      openInaNewTab(contract.get('docUrl'));
    },
  });
};

const displayPromotionsAndTermsAndConditions = async () => {
  tracker?.event('PrivacyPolicyClicked', 'Get info', 'Click on link');
  const [MarketplaceConnector, TCDocumentFactory] = await requirejs<[any, any]>([
    'DS/MPFDataProxy/MarketplaceConnector',
    'DS/MPFTcDocumentModel/TCDocumentFactory',
  ]);

  const connector = await MarketplaceConnector.fetchPromise();
  const docFacto = new TCDocumentFactory(connector);
  const contract = docFacto.createModel(TCDocumentFactory.Types.COUPON);

  contract.fetch({
    onComplete() {
      openInaNewTab(contract.get('docUrl'));
    },
  });
};

const displayPrivacyAndPolicy = async () => {
  const [MarketplaceConnector, TCDocumentFactory] = await requirejs<[any, any]>([
    'DS/MPFDataProxy/MarketplaceConnector',
    'DS/MPFTcDocumentModel/TCDocumentFactory',
  ]);

  const connector = await MarketplaceConnector.fetchPromise();
  const docFacto = new TCDocumentFactory(connector);
  const contract = docFacto.createModel('privacy-policy');

  contract.fetch({
    onComplete() {
      openInaNewTab(contract.get('docUrl'));
    },
  });
};

const openInaNewTab = (url: string) => {
  // SAFARI Prevent Using Window.open in a async callback so this is a workaround
  setTimeout(() => window.open(url, '_blank'), 0);
};
</script>
<template>
  <div class="footer-container flex flex-column--sm align-items-center">
    <div class="flex-grow-1 align-items-center" id="copyright">
      <span class="copyright-year">&copy; {{ new Date().getFullYear() }} | </span>
      <span>{{ $i18n('allRightReserved') }}</span>
    </div>
    <div class="flex-grow-1 align-items-center" id="terms-and-conditions">
      <a @click.prevent="displayGeneralTermsAndConditions()" href="#">
        {{ $i18n('generalTermsAndConditions') }}
      </a>
    </div>
    <div class="flex-grow-1 align-items-center" id="special-offers">
      <a
        id="promotionsTermsAndConditions"
        @click.prevent="displayPromotionsAndTermsAndConditions()"
        href="#"
      >
        {{ $i18n('promotionsTermsAndConditions') }}
      </a>
    </div>
    <div class="flex-grow-1 align-items-center" id="privacy-policy">
      <a @click.prevent="displayPrivacyAndPolicy()" href="#">{{ $i18n('privacyPolicy') }}</a>
    </div>
  </div>
</template>
<style scoped lang="scss">
@use '/assets/scss/variables' as variables;

.footer-container {
  font-family: '3ds';
  background-color: var(--blue-5);
  color: #65899b;
  min-height: 40px;
  padding: 0 40px;
  border: 1px solid var(--blue-5);
  padding: 10px 40px;

  @include variables.for-sm {
    padding: 4px 0;
    min-height: unset;
    flex-direction: column-reverse;
  }
}

a,
a:hover,
a:active,
a:focus {
  color: #65899b;
  cursor: pointer;
}
</style>
